import { randInt, simplify } from '../utils/fractionMath';

export function generateTopic2Questions(count = 10) {
  const questions = [];
  for (let i = 0; i < count; i++) {
    const den = randInt(3, 10);
    const isAdd = Math.random() < 0.5;
    let num1, num2;

    if (isAdd) {
      num1 = randInt(1, den - 2);
      num2 = randInt(1, den - num1 - 1); // sum < den (avoid whole number result)
    } else {
      num1 = randInt(2, den - 1);
      num2 = randInt(1, num1 - 1); // difference > 0
    }

    const rawNum = isAdd ? num1 + num2 : num1 - num2;
    const { num: sNum, den: sDen } = simplify(rawNum, den);
    const operator = isAdd ? '+' : '−';

    questions.push({
      id: `t2_${i}`,
      topicId: 2,
      type: 'addsub',
      prompt: 'Aprēķini!',
      data: { num1, den1: den, num2, den2: den, operator },
      correctAnswer: { num: sNum, den: sDen },
    });
  }
  return questions;
}
